import React from 'react';

/**
 * B-50 Phase 0 — wraps a React.lazy page. After a deploy the old chunk file
 * is gone, so an open tab's import() fails; instead of a blank screen, offer
 * a reload (which fetches the new build). Any other render error lands here
 * too, with the same way out.
 */
export default class LazyPageBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(err) {
    // eslint-disable-next-line no-console
    console.error('[LazyPageBoundary]', err);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" style={{
        minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', gap: 14, padding: '24px 16px', textAlign: 'center',
        background: 'var(--surface)', color: 'var(--charcoal)', fontFamily: "'Nunito', sans-serif",
      }}>
        <p style={{ fontSize: 16, fontWeight: 700, margin: 0 }}>This page didn’t load.</p>
        <p style={{ fontSize: 14, margin: 0, color: 'var(--text-secondary)' }}>
          Marakin may have just been updated — reloading picks up the new version.
        </p>
        <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
          Reload
        </button>
      </div>
    );
  }
}
